<template>
  <div
    class="base-upload-button__div"
    :class="{ 'drag-over': isDragOver }"
    @dragenter.prevent="onDragEnter"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
  >
    <v-file-input
      v-bind="defaultConfigs"
      v-model="addedFiles"
      :multiple="multiple"
      class="base-upload-button__button"
      prepend-icon=""
      @change="updateFiles"
    />
    <div
      class="base-upload-button__content text-center py-4 mb-4 mb-sm-2"
      v-if="!isProfile"
    >
      <SvgIcon name="upload" color="gray90" />
      <p
        class="subtitle-2 mb-2 gray90--text"
        v-if="$vuetify.breakpoint.smAndUp && !mini"
      >
        {{
          multiple
            ? $t("upload.dragDropPrefix")
            : $t("upload.dragDropPrefixSingle")
        }}
        <label class="purple100--text">
          {{
            multiple
              ? $t("upload.dragDropMiddle")
              : $t("upload.dragDropMiddleSingle")
          }}
        </label>
        <label class="purple100--text text-decoration-underline">
          {{
            multiple
              ? $t("upload.dragDropSuffix")
              : $t("upload.dragDropSuffixSingle")
          }}
        </label>
      </p>
      <p
        class="subtitle-2 mb-2 purple100--text text-decoration-underline"
        v-else
      >
        {{
          multiple
            ? $t("upload.dragDropSuffix")
            : $t("upload.dragDropSuffixSingle")
        }}
      </p>
      <p class="caption mb-0 gray90--text">
        {{ $t("upload.recommended") }} {{ sizeImage }}
      </p>
    </div>
    <slot v-else />
  </div>
</template>
<script lang="ts">
import { CustomFileUpload } from "@/types";
import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash";
import Bowser from "bowser";
@Component
export default class BaseUploadButton extends Vue {
  @Prop(String) idName: string;
  @Prop({ default: false }) dropFiles: boolean;
  @Prop(String) textButton: string;
  @Prop({ default: "" }) backgroundPhoto: string;
  @Prop({ default: 100 }) backgroundHeight: number;
  @Prop({ default: false }) big: boolean;
  @Prop({ default: false }) optional: boolean;
  @Prop({ default: true }) multiple: boolean;
  @Prop({ default: false }) post: boolean;
  @Prop({ default: false }) isProfile: boolean;
  @Prop({ default: "1400x1400" }) sizeImage: string;
  @Prop({ default: false }) mini: boolean;
  @Prop({
    default:
      "image/jpeg, image/png, image/gif, image/bmp, image/tiff, image/tif, image/webp, image/heif, image/heic, image/svg+xml, ",
  })
  acceptedFileTypes: string;
  headers = {
    "X-Csrf-Token": "xxxx",
  };
  dataToken = {
    _csrf_token: "xxxxxx",
  };
  isDragOver = false;
  addedFiles: any = [];

  get defaultConfigs() {
    let result = Bowser.getParser(window.navigator.userAgent);
    const acceptItems =
      result.getBrowser().name === "Safari"
        ? this.acceptedFileTypes
        : this.acceptedFileTypes + ", capture=camera";
    return Object.assign(
      {
        ref: "upload",
        "add-index": false,
        accept: acceptItems,
        "put-action": "/upload/put",
        directory: false,
        headers: this.headers,
        data: this.dataToken,
        drop: this.dropFiles,
        "input-id": this.idName,
        "post-action": "/upload/post",
      },
      {
        ...this.$attrs,
        ...this.$props,
      }
    );
  }
  updateFiles(value: any): void {
    if (_.isNull(value) || !value) return;
    if (_.isArray(value)) {
      value.forEach((item: CustomFileUpload) => {
        this.inputFilter(item);
      });
      this.$emit("input", value);
      this.addedFiles = [];
    } else {
      this.inputFilter(value);
      this.$emit("input", [value]);
      this.addedFiles = [];
    }
  }
  isVideo(item: CustomFileUpload): boolean {
    return item && (item.type.includes("video") || item.type === "VIDEO");
  }
  inputFilter(file: any) {
    if (this.post && !this.isVideo(file)) return;
    file.blob = "";
    const URL = window.URL || window.webkitURL;
    if (URL && URL.createObjectURL) file.blob = URL.createObjectURL(file);
  }
  onDragEnter(event: DragEvent) {
    if (this.dropFiles) {
      event.preventDefault();
      this.isDragOver = true;
    }
  }

  onDragOver(event: DragEvent) {
    if (this.dropFiles) {
      event.preventDefault();
    }
  }

  onDragLeave(event: DragEvent) {
    // Verifica se o mouse saiu completamente do elemento
    const relatedTarget = event.relatedTarget as HTMLElement | null;
    if (!relatedTarget || !this.$el.contains(relatedTarget)) {
      this.isDragOver = false;
    }
  }

  onDrop(event: DragEvent) {
    this.isDragOver = false;
    if (this.dropFiles && event.dataTransfer) {
      const files = event.dataTransfer.files;

      if (files.length > 0) {
        const fileList = this.multiple ? Array.from(files) : [files[0]];

        this.addedFiles = fileList;
        this.updateFiles(fileList);
      }
    }
  }
}
</script>
<style lang="sass">
.base-upload-button__
  &button
    width: 100%
    position: absolute
    opacity: 0
    z-index: 99
    cursor: pointer
    padding: 0
    margin: 0
    height: 100%
    .v-input__control
      height: 100%
      .v-input__slot
        min-height: 100%
        cursor: pointer
        .v-text-field__slot
          height: 100%
  &div
    position: relative
  &content
    background: var(--v-purple40-base)
    border: 1px dashed var(--v-purple100-base)
    border-radius: 8px
    cursor: pointer
    margin: 0 auto
    width: 100%
    height: 130px !important
  &border-file-upload
    border: 1px dashed var(--v-purple100-base)
    border-radius: 8px
  &delete-button
    min-width: auto !important
  &img-upload
    width: 60px !important
    height: 42px !important
    border-radius: 8px
    position: relative
.file-uploads.file-uploads-html5 label
  cursor: pointer
</style>
